export const PROGRAM_EVIDENCE_COMPONENT_TYPES = Object.freeze([
  "status",
  "metric",
  "metadata",
]);

const isObject = value => Boolean(value) && typeof value === "object" && !Array.isArray(value);
const isText = value => typeof value === "string" && value.trim().length > 0;
const validProvider = provider => isObject(provider) && isText(provider.key) && isText(provider.version);
const validProgram = program => isObject(program) && isText(program.id) && isText(program.slug) && isText(program.version);
const validProvenance = provenance => isObject(provenance) &&
  isText(provenance.projectionVersion) && Array.isArray(provenance.sources) &&
  provenance.sources.every(source => isObject(source) && isText(source.type) && isText(source.reference));

const validComponent = component => {
  if (!isObject(component) || !isText(component.key) ||
      !PROGRAM_EVIDENCE_COMPONENT_TYPES.includes(component.type) ||
      !isText(component.label)) return false;
  if (component.type === "status") return isText(component.value);
  if (component.type === "metric") return typeof component.value === "number" && Number.isFinite(component.value);
  return Array.isArray(component.items) && component.items.length > 0 &&
    component.items.every(item => isObject(item) && isText(item.label) && isText(item.value));
};

export function validateProgramEvidencePayload(payload) {
  if (!isObject(payload) || payload.contractVersion !== "1.0" ||
      !["available", "partial", "unavailable", "not_supported"].includes(payload.availability) ||
      !Array.isArray(payload.components) || !validProgram(payload.program) ||
      !validProvenance(payload.provenance)) return false;
  if (["available", "partial"].includes(payload.availability) &&
      (!validProvider(payload.provider) || payload.components.length === 0)) return false;
  if (payload.availability === "unavailable" && !validProvider(payload.provider)) return false;
  if (payload.availability === "not_supported" && payload.provider !== null && !validProvider(payload.provider)) return false;
  if (["unavailable", "not_supported"].includes(payload.availability) && payload.components.length > 0) return false;
  return payload.components.every(validComponent) &&
    new Set(payload.components.map(component => component.key)).size === payload.components.length;
}
